import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // User management states
  users: [],
  profile: {},
  usersLoading: false,
  usersError: null,
  selectedUser: null,
  userEssays: [],
  userEssaysLoading: false,
  userEssaysError: null,
  // Flagged content states
  flaggedContent: [],
  flaggedLoading: false,
  flaggedError: null,
  // Submissions states
  submissions: [],
  submissionsLoading: false,
  submissionsError: null,
  selectedSubmission: null,
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setUsers(state, action) {
      state.users = action.payload;
    },
    setProfile(state, action) {
      state.profile = action.payload;
    },
    setUsersLoading(state, action) {
      state.usersLoading = action.payload;
    },
    setUsersError(state, action) {
      state.usersError = action.payload;
    },
    setSelectedUser(state, action) {
      state.selectedUser = action.payload;
    },
    setUserEssays(state, action) {
      state.userEssays = action.payload;
    },
    setUserEssaysLoading(state, action) {
      state.userEssaysLoading = action.payload;
    },
    setUserEssaysError(state, action) {
      state.userEssaysError = action.payload;
    },
    setFlaggedContent(state, action) {
      state.flaggedContent = action.payload;
    },
    setFlaggedLoading(state, action) {
      state.flaggedLoading = action.payload;
    },
    setFlaggedError(state, action) {
      state.flaggedError = action.payload;
    },
    setSubmissions(state, action) {
      state.submissions = action.payload;
    },
    setSubmissionsLoading(state, action) {
      state.submissionsLoading = action.payload;
    },
    setSubmissionsError(state, action) {
      state.submissionsError = action.payload;
    },
    setSelectedSubmission(state, action) {
      state.selectedSubmission = action.payload;
    },
    clearUsersError(state) {
      state.usersError = null;
    },
    clearUserEssaysError(state) {
      state.userEssaysError = null;
    },
    clearFlaggedError(state) {
      state.flaggedError = null;
    },
    clearSubmissionsError(state) {
      state.submissionsError = null;
    },
  },
});

export const {
  setUsers,
  setProfile,
  setUsersLoading,
  setUsersError,
  setSelectedUser,
  setUserEssays,
  setUserEssaysLoading,
  setUserEssaysError,
  setFlaggedContent,
  setFlaggedLoading,
  setFlaggedError,
  setSubmissions,
  setSubmissionsLoading,
  setSubmissionsError,
  setSelectedSubmission,
  clearUsersError,
  clearUserEssaysError,
  clearFlaggedError,
  clearSubmissionsError,
} = globalSlice.actions;

export default globalSlice.reducer;
